import { FilterKeywords, FiltersModel } from "../../../common";

export class ManifestFiltersModel extends FiltersModel {
  trackingNumber: string;
  type: string;
  shipped: string;
  shippingDate: Date;
  updatedBy: string;

  constructor(state?: string) {
    super();

    this.setState(state);
  }

  setState(input: string): string {
    input = super.setState(input);

    if (!input) return;

    let mappings: FilterKeywords[] = [
      {
        keyword: "shipping-date",
        setter: (value) => (this.shippingDate = new Date(value)),
      },
      {
        keyword: "type",
        setter: (value) => (this.type = this.clean(value)),
      },
      {
        keyword: "updated-by",
        setter: (value) => (this.updatedBy = this.clean(value)),
      },
      {
        keyword: "shipped",
        setter: (value) => (this.shipped = this.yesOrNo(value)),
      },
      {
        keyword: "id",
        setter: (value) => (this.trackingNumber = value),
      },
    ];

    mappings.forEach((mapping) => {
      input = this.testValues(input, mapping);
    });

    return null;
  }

  getState(): string {
    let filters: string[] = [],
      superState = super.getState();

    if (this.trackingNumber) filters.push(this.encode(this.trackingNumber));
    if (this.type) filters.push(`type-${this.encode(this.type)}`);
    if (this.shippingDate) filters.push(`shipping-date-${this.shippingDate.toLocaleDateString()}`);
    if (this.updatedBy) filters.push(`updated-by-${this.encode(this.updatedBy)}`);
    if (this.shipped) filters.push(`shipped-${this.encode(this.shipped)}`);

    if (superState) filters.push(superState);

    return filters.join(" ");
  }

  public serializeFrom(stateBug: {}): void {
    Object.keys(stateBug).forEach((key) => {
      let value = decodeURI(stateBug[key]).trim();
      switch (key) {
        case "id":
          this.trackingNumber = value;
          break;
        case "type":
          this.type = value;
          break;
        case "shippingDate":
          this.shippingDate = new Date(value);
          break;
        case "updatedBy":
          this.updatedBy = value;
          break;
        case "shipped":
          this.shipped = value;
          break;
      }
    });
  }

  public serializeTo(stateBug: {}): void {
    if (this.trackingNumber) stateBug["id"] = this.trackingNumber.trim();
    if (this.type) stateBug["type"] = this.type.trim();
    if (this.shippingDate) stateBug["shippingDate"] = this.shippingDate;
    if (this.updatedBy) stateBug["updatedBy"] = this.updatedBy;
    if (this.shipped) stateBug["shipped"] = this.shipped;
  }
}
